<template>
  <img v-if="imageSource" class="content-type-icon" :src="imageSource" alt="" />
</template>

<script>
import { getCdnImageUrl } from '@/utils/network'
import { ContentType } from '@/enums'

/**
 * Renders an icon for the given meta model type.
 * If no icon exists for the type nothing is rendered.
 *
 * @author Thomas Grinderslev <lritgr@egmont.com>
 */
export default {
  name: 'ContentTypeIcon',
  props: {
    contentType: {
      type: String,
      required: true,
      validator(contentType) {
        return Object.values(ContentType).includes(contentType)
      },
    },
  },
  computed: {
    /**
     * The file name of the icon associated with the meta model type. Or null if no image exists.
     * @return {string|null}
     */
    iconFileName() {
      switch (this.contentType) {
        case ContentType.ACTIVITY:
          return 'activity'
        case ContentType.ADAPTIVE_TEST:
          return 'adaptiveTest'
        case ContentType.BOOKS:
          return 'books'
        case ContentType.DIFFERENTIATED_TEST:
          return 'diffTest'
        case ContentType.GEOMETRY:
          return 'geometry'
        case ContentType.HOMEWORK:
          return 'homework'
        case ContentType.LESSON:
          return 'lesson'
        case ContentType.PDF_ASSIGNMENT:
          return 'pdfAssignment'
        case ContentType.SELF_TRAINING:
        case ContentType.STANDARD_EXERCISE:
        case ContentType.TRIAL_EXAM:
          return 'standardExercise'
      }

      return null
    },
    /**
     * The full URL for the image to use as an icon. Or null if no image exists.
     * @return {string|null}
     */
    imageSource() {
      if (this.iconFileName) {
        return getCdnImageUrl(
          `/fessor/teacher/contentsearch/${this.iconFileName}.svg`
        )
      }

      return null
    },
  },
}
</script>
